module.exports = __webpack_public_path__ + "static/media/ic_logo.b684b141.png";